import email from '../assets/email.svg';
import whatsapp from "../assets/whatsapp.svg"
import agrihyphen from "../assets/agrihyphen.svg"
import consulting from "../assets/Consulting.svg"

import circle from '../assets/circle.svg';
import hyphenlogo from '../assets/hyphenlogo.png'
import hyphensvg from '../assets/hyphensvg.svg'

import hyphenimage from "../assets/4.png"
import cosebuLogo from "../assets/Cosebu.png"

// Default fallback image
import fallbackImage from '../assets/hyphenlogo.png';
import yan1 from "../assets/yan.jpeg"
import ifb1 from "../assets/ifb-audience.png"
import diego1 from "../assets/Diego.png"
import speech1 from "../assets/speech.jpg"
import education1 from "../assets/education.jpg"
import innovation1 from "../assets/innovation-week.jpg"

// Map product image paths to their public URLs
const productImages = {
  // Legacy t-shirt images
  './img/tshirt-gray.png': '/img/tshirt-gray.png',
  './img/tshirt-navy.png': '/img/tshirt-navy.png',
  './img/tshirt-black.png': '/img/tshirt-black.png',
  './img/tshirt-white.png': '/img/tshirt-white.png',
  
  // Hyphen Tech t-shirts
  './img/hyphenTech/hyphen-black.png': '/img/hyphenTech/hyphen-black.png',
  './img/hyphenTech/hyphen-white.png': '/img/hyphenTech/hyphen-white.png',
  './img/hyphenTech/hyphen-gray.png': '/img/hyphenTech/hyphen-gray.png',
  './img/hyphenTech/hyphen-blue.png': '/img/hyphenTech/hyphen-blue.png',
  './img/hyphenTech/hyphen-green.png': '/img/hyphenTech/hyphen-green.png',
  
  // AgriHyphen AI t-shirts
  './img/Agrihyphen-Ai/agrihyphen-black.png': '/img/Agrihyphen-Ai/agrihyphen-black.png',
  './img/Agrihyphen-Ai/agrihyphen-white.png': '/img/Agrihyphen-Ai/agrihyphen-white.png',
  './img/Agrihyphen-Ai/agrihyphen-gray.png': '/img/Agrihyphen-Ai/agrihyphen-gray.png',
  './img/Agrihyphen-Ai/agrihyphen-blue.png': '/img/Agrihyphen-Ai/agrihyphen-blue.png',
  './img/Agrihyphen-Ai/agrihyphen-green.png': '/img/Agrihyphen-Ai/agrihyphen-green.png',
  
  // Cosebu t-shirts
  './img/cosebu/cosebu-black.png': '/img/cosebu/cosebu-black.png',
  './img/cosebu/cosebu-white.png': '/img/cosebu/cosebu-white.png',
  './img/cosebu/cosebu-gray.png': '/img/cosebu/cosebu-gray.png',
  './img/cosebu/cosebu-blue.png': '/img/cosebu/cosebu-blue.png',
  './img/cosebu/cosebu-green.png': '/img/cosebu/cosebu-green.png'
};

// Map image paths to their fallback
const blogImages = {
  './photos/yan.jpeg': yan1,
  './photos/ifb-audience.png': ifb1,
  './photos/Diego.png': diego1,
  './photos/speech.jpg': speech1,
  './photos/education.jpg': education1,
  './photos/innovation-week.jpg': innovation1,
};

export const getBlogImage = (imagePath) => {
  return blogImages[imagePath] || fallbackImage;
};

export const getProductImage = (imagePath) => {
  // Remove leading './' if present to handle both './img/...' and 'img/...' formats
  const cleanPath = imagePath?.startsWith('./') ? imagePath.substring(2) : imagePath;
  // Check if we have a mapped path, otherwise use the path as is
  return productImages[imagePath] || `/${cleanPath}` || fallbackImage;
};

export const getProjectImage = (imagePath) => {
  if (!imagePath || typeof imagePath !== 'string') return fallbackImage;

  const trimmedPath = imagePath.trim();
  if (!trimmedPath) return fallbackImage;

  if (/^(https?:)?\/\//i.test(trimmedPath) || trimmedPath.startsWith('data:') || trimmedPath.startsWith('blob:')) {
    return trimmedPath;
  }

  const normalizedPath = trimmedPath.replace(/\\/g, '/').replace(/^\.\//, '/');
  const withLeadingSlash = normalizedPath.startsWith('/') ? normalizedPath : `/${normalizedPath}`;

  return encodeURI(withLeadingSlash);
};

const images = {
  email,
  hyphenimage,
  whatsapp,
  circle,
  hyphenlogo,
  hyphensvg,
  fallbackImage,
  agrihyphen,
  consulting,
  cosebuLogo,
  getBlogImage,
  getProductImage,
  getProjectImage
};

export default images;
